<button
  [disabled]="!(egiAppQueries.shouldBeSynced$ | async)"
  eBtn
  icon="sync"
  color="danger"
  block
  size="sm"
  (click)="onClick()"
  [loading]="loading"
  >
  Sync pagina's
</button>

<e-dialog
  title="Foute configuratie gevonden!"
  [(open)]="showErrorDialog"
  size="responsive"
  color="danger"
  >
  <ng-template>
    <h3>Contacteer Egi support! (bram.sommen&#64;robberechts.be)</h3>
    <div style="display: grid; grid-template-columns: 1fr 5fr" class="m-2">
      <i eIcon size="3x" class="text-danger" icon="exclamation-circle"></i>
      <div>
        Onderstaande doorklikpagina's bestaan niet: <br /><br />

        <table>
          <thead>
            <th>Pagina</th>
            <th>Doorklikpagina</th>
          </thead>
          <tbody>
            @for (faultyConfig of faultyConfiguredClickTroughPages; track faultyConfig) {
              <tr>
                <td>
                  {{ faultyConfig?.page.config.name }} <br />
                  ({{ faultyConfig?.page.config.id }})
                </td>
                <td>{{ faultyConfig?.faultyId }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </ng-template>
</e-dialog>
